// Base server URL for this deployment. Set via REACT_APP_API_URL at build
// time (see .env.example) — no default baked in, since every self-hosted
// deployment points at a different server.
const url1 = process.env.REACT_APP_API_URL || 'http://localhost:4001';
const ASSETS_URL = process.env.REACT_APP_ASSETS_URL || `${url1}/api`;

export const TMP_URL = url1;
// Optional: only needed if this deployment wants direct Google Sign-In on
// web (separate from the Firebase-based OAuth in helper/firebase.ts). Leave
// unset to disable.
export const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const Env = {
    ApiUrl: `${TMP_URL}/api/`,
    SocketUrl: TMP_URL,
    AssetsUrl: ASSETS_URL,
};

export const project_version = '2.0';
